/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useTranslation } from 'react-i18next';
import { REGION_STRINGS } from '../../Constants/Strings.constants';
import { DxpTenantRegionCode } from '../../Services/console';

/**
 * React hook to return a translation map for each region code.
 */
export function useRegion(): Record<DxpTenantRegionCode, string> {
  const { t } = useTranslation();

  return {
    [DxpTenantRegionCode.au]: t(REGION_STRINGS.au),
    [DxpTenantRegionCode.uk]: t(REGION_STRINGS.uk),
    [DxpTenantRegionCode.us]: t(REGION_STRINGS.us),
  };
}
